import { createContext } from 'react';
import { MapsApiServices, MapsLibraries } from '../common/types';

export interface GoogleMapsApiServiceContextState {
    mapsApi?: MapsApiServices;
    setApi: (mapsLibraries: MapsLibraries, mapRef: any) => void;
}

export const GoogleMapsApiServiceContext = createContext<GoogleMapsApiServiceContextState>({ mapsApi: undefined, setApi: () => {} });